import React, { useEffect } from "react";
import { Paper,Image,Flex} from "@mantine/core";
import styled from "styled-components";
import { getPathname } from "utils/getPathname";

import cleanUri from "img/clean.png"
import cloudyUri from "img/cloudy.png"
import lotOfCloudUri from "img/lotOfCloud.png"
import rainUri from "img/rain.png"
import rain_snowUri from "img/rain_snow.png"
import snowUri from "img/snow.png"
import clean_nightUri from "img/clean_night.png"
import lotOfCloud_nightUri from "img/lotOfCloud_night.png"

/** 날씨*/
const ComponentG = (props) => {
  const { 
    bsdId,
    weather,
  } = props;
  
  const pathName = getPathname();
  const wthrData = weather?.find(v => v.bsd_id === bsdId);
  
  let isNight = false;
  const time = Number(wthrData?.w_1.substr(0,2));
  if(time >= 19 || time <= 6) {
    isNight = true;
  }
/*  
  useEffect(() => {
    if (pathName === "site_edit"  || !wthrData || wthrData.length < 1) return;  
    const time = Number(wthrData.w_1.substr(0,2));
    if(time >= 19 || time <= 6) {
      isNight = true;
    }
  },[bsdId]);
*/

  const imgUri = {
    "맑음": isNight ? clean_nightUri : cleanUri,
    "구름많음": isNight ? lotOfCloud_nightUri : lotOfCloudUri,
    "흐림": cloudyUri,
    "비": rainUri,
    "비/눈": rain_snowUri,
    "눈": snowUri,
    "빗방울": rainUri,
    "빗방울눈날림": rain_snowUri,
    "눈날림": snowUri
  }

  const column = [
    {
      title: "대기 온도",
      value: wthrData?.w_3  ??  "--",
    },
    {
      title: "대기 습도",
      value: wthrData?.w_4 ?? "--",
    },
    {
      title: " 풍 속 ",
      value: wthrData?.w_5 ?? "--",
    },
  ];

  return (
    <>
    <Flex >
      <div>
        <Image
          src={imgUri[wthrData?.w_2]}
  //        alt="With default placeholder"
          fit="none"
  //        withPlaceholder  
        />
      </div>
      <Flex style={{ display: "flex", gap: 8 , }}>
      { column.map((v) => {
        return (
          <div
            key={v.title}
            style={{
              display: "flex",
              flexDirection: "column",
              background: "#DCDCDC",
              border: "1px solid #DCDCDC",
              // padding: 8,
              borderRadius: 4,
              width:"69px",
              textAlign :"center",
            }}
          >
            <div style={{ fontSize: 12, padding: "4px 8px" }}>{v.title}</div>
            <div
              style={{
                fontSize: 16,
                background: "white",
                padding: "4px 8px",
                borderBottomLeftRadius: 4,
                borderBottomRightRadius: 4,
                textAlign:"center",
              }}
            >
              {v.value}
            </div>
          </div>    
        );
      })}
      </Flex> 
      </Flex>
      <Flex 
          style={{ 
            fontSize: 12, 
            padding: "2px 4px" ,
            color:"gray",
   //         width:"360px",
            textAlign:"center",
          }}
      >
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;기상청 &nbsp;&nbsp;
          {wthrData?.w_0.substr(0,4)}년{wthrData?.w_0.substr(4,2)}월{wthrData?.w_0.substr(6,2)}일
          &nbsp;{wthrData?.w_1.substr(0,2)}시{wthrData?.w_1.substr(2,2)}분 &nbsp;예보
      </Flex>
    
    </>
    );
};

const WrapComponent = styled(Paper)`
width: 100%;
display: flex;
justify-content: center;
align-items: center;
`;

//export default React.memo(ComponentG);
export default ComponentG;
